/** An editor content viewer for deviations description */ import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import BaseViewer from './Base';
import deviationTheme from '../Themes/Viewer/deviation.scss';
const DeviationViewer = (props)=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: 'da-editor-comments'
    }, /*#__PURE__*/ React.createElement(BaseViewer, _extends({
        theme: deviationTheme,
        showMediaAlwaysSmall: true,
        fixedParagraph: false
    }, props)));
};
export default DeviationViewer;
